import { SVG_STROKE_WIDTH, SVG_BAR_WIDTH, SVG_CIRCLE_RADIUS, SVG_CIRCLE_WHITESPACE } from './constants.js';
import { toCssPrecision } from './util.js';

// The bar path width is twice the visible bar width to enable the movement
// animation using translation transform along the X axis.
const barPath = `M ${toCssPrecision(-SVG_BAR_WIDTH)},${SVG_STROKE_WIDTH} l ${toCssPrecision(2 * SVG_BAR_WIDTH)},0`;
const circlePath = `M ${2 * SVG_CIRCLE_RADIUS + SVG_CIRCLE_WHITESPACE},${SVG_CIRCLE_RADIUS + SVG_CIRCLE_WHITESPACE}
a ${SVG_CIRCLE_RADIUS},${SVG_CIRCLE_RADIUS} 0 1,1 ${-2 * SVG_CIRCLE_RADIUS},0
a ${SVG_CIRCLE_RADIUS},${SVG_CIRCLE_RADIUS} 0 1,1 ${2 * SVG_CIRCLE_RADIUS},0
Z`;

export { barPath, circlePath };
//# sourceMappingURL=paths.js.map
